import { useAsync } from "react-async";
import axios from "axios";
import {
  getNotifications,
  getArchiveNotifications,
  markNotificationAsRead,
  removeNotification
} from "../api";

/**
 * @param {Object} [options]
 * @param {Boolean} [options.fromArchive=false] - If true will return all the
 *  notifications from the last 30 days. If false will return the latest 25 that
 *  haven't being removed.
 */
const useNotifications = ({ fromArchive = false, companyId } = {}) => {
  const source = axios.CancelToken.source();
  const {
    data: notifications,
    error,
    isPending: loading,
    setData,
    setError,
    reload
  } = useAsync({
    promiseFn: fromArchive ? getArchiveNotifications : getNotifications,
    onReject: err => err.name === "AbortError" && source.cancel(err.message),
    cancelToken: source.token,
    companyId
  });

  const markAsRead = async notification => {
    try {
      await markNotificationAsRead(notification);
      setData(
        notifications.map(item =>
          item.id === notification.id ? { ...item, read: true } : item
        )
      );
    } catch (err) {
      setError(err);
    }
  };

  const remove = async notification => {
    try {
      await removeNotification(notification);
      setData(notifications.filter(item => item.id !== notification.id));
    } catch (err) {
      setError(err);
    }
  };

  return {
    notifications,
    error,
    loading,
    markAsRead,
    remove,
    reload
  };
};

export default useNotifications;
